import getGlobal from './utils/getGlobal';
var g = getGlobal();
/**
 * @deprecated use `cancelAnimationFrame` instead
 */

export default g.cancelAnimationFrame || g.clearTimeout;